<template>
    <el-row>
        <el-col :md="11" :sm="11">
            <el-input :disabled="disabled" v-model="formBeginTime" @change="timeStartChange" placeholder="请输入内容"></el-input>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :md="11" :sm="11">
            <el-input :disabled="disabled" v-model="formEndTime" @change="timeEndChange" placeholder="请输入内容"></el-input>
        </el-col>
    </el-row>
</template>

<script>
export default {
    data(){
        return {
            formBeginTime:'',
            formEndTime:""
        }
    },
    props:{
        timeInfo:{
            require:false,
            default:[]
        },
        disabled:{
            require:false,
            default:false
        },
        dataLink:{
            require:false,
            default:false
        }
    },
    watch:{
        timeInfo:{
            handler(newVal){
                this.formBeginTime = newVal[0]?newVal[0]:''
                this.formEndTime = newVal[1]?newVal[1]:'';
                this.$forceUpdate();
            },
            deep:true
        }   
    },
    created(){
        this.formBeginTime = this.timeInfo[0]?this.timeInfo[0]:''
        this.formEndTime = this.timeInfo[1]?this.timeInfo[1]:'';
    },
    methods:{
        timeStartChange(val){
           this.dataLink?this.formEndTime = Number(this.formBeginTime)+3:''
            this.$emit('change',[this.formBeginTime,this.formEndTime])
        },
        timeEndChange(val){
            this.dataLink?this.formBeginTime = Number(this.formEndTime)-3:''
            this.$emit('change',[this.formBeginTime,this.formEndTime])
        },
    }
}
</script>

<style lang="scss" scoped>
    .line{
        padding: 0 5px !important;
        text-align: center;
    }
</style>